import { useFormContext } from "react-hook-form";
import { IConfigRegua } from "../../../../../../Interfaces/Automacao/Regua/ConfiguracaoDeRegua/ConfiguracaoDeReguaInterfaces";

interface ISMSProps {
    configRegua?: IConfigRegua;
}

interface ISMSFormData {
    ID_SERVICO_SMS: number;
    DS_USUARIO_SMS: string;
    DS_SENHA_SMS: string;
    cDS_SENHA_SMS: string;
    NR_TELEFONE_RECEPTIVO_TESTE: string;
    NR_MAX_SMS: number;
    DS_ID_AGRUPAMENTO: string;
}

export default function SMS(props: ISMSProps) {
    const { register, formState, watch } = useFormContext<ISMSFormData>();

    const watcher = watch("ID_SERVICO_SMS", props.configRegua?.ID_SERVICO_SMS);

    return (
        <div className="row">
            <div className="form-group col-12 col-lg-6">
                <label>Serviço de SMS</label>
                <select
                    className={`form-control placeholder-dark-75 ${
                        formState.errors.ID_SERVICO_SMS && "is-invalid"
                    }`}
                    defaultValue={props.configRegua?.ID_SERVICO_SMS}
                    name="ID_SERVICO_SMS"
                    ref={register({
                        valueAsNumber: true,
                    })}
                >
                    <option></option>
                    <option value={1}>Zenvia</option>
                    <option value={2}>TWW</option>
                </select>
                <div className="invalid-feedback">
                    {formState.errors.ID_SERVICO_SMS
                        ? formState.errors.ID_SERVICO_SMS.message
                        : ""}
                </div>
            </div>
            <div className="form-group col-12 col-lg-6">
                <label>Usuário do serviço</label>
                <input
                    className={`form-control placeholder-dark-75 ${
                        formState.errors.DS_USUARIO_SMS && "is-invalid"
                    }`}
                    type="text"
                    defaultValue={props.configRegua?.DS_USUARIO_SMS || ""}
                    name="DS_USUARIO_SMS"
                    ref={register()}
                />
                <div className="invalid-feedback">
                    {formState.errors.DS_USUARIO_SMS
                        ? formState.errors.DS_USUARIO_SMS.message
                        : ""}
                </div>
            </div>
            <div className="form-group col-12 col-lg-6">
                <label>Senha do Serviço</label>
                <input
                    className={`form-control placeholder-dark-75 ${
                        formState.errors.DS_SENHA_SMS && "is-invalid"
                    }`}
                    type="password"
                    defaultValue={props.configRegua?.DS_SENHA_SMS || ""}
                    name="DS_SENHA_SMS"
                    ref={register()}
                />
                <div className="invalid-feedback">
                    {formState.errors.DS_SENHA_SMS
                        ? formState.errors.DS_SENHA_SMS.message
                        : ""}
                </div>
            </div>
            <div className="form-group col-12 col-lg-6">
                <label>Confirme a Senha</label>
                <input
                    className={`form-control placeholder-dark-75 ${
                        formState.errors.cDS_SENHA_SMS && "is-invalid"
                    }`}
                    type="password"
                    defaultValue={props.configRegua?.DS_SENHA_SMS || ""}
                    name="cDS_SENHA_SMS"
                    ref={register()}
                />
                <div className="invalid-feedback">
                    {formState.errors.cDS_SENHA_SMS
                        ? formState.errors.cDS_SENHA_SMS.message
                        : ""}
                </div>
            </div>
            <div className="form-group col-12 col-lg-6">
                <label>Telefone Receptivo de Testes</label>
                <input
                    className={`form-control placeholder-dark-75 ${
                        formState.errors.NR_TELEFONE_RECEPTIVO_TESTE &&
                        "is-invalid"
                    }`}
                    type="number"
                    defaultValue={
                        props.configRegua?.NR_TELEFONE_RECEPTIVO_TESTE
                    }
                    name="NR_TELEFONE_RECEPTIVO_TESTE"
                    min={0}
                    ref={register({
                        min: {
                            value: 0,
                            message: "Insira um número máximo de SMS válido",
                        },
                    })}
                />
                <div className="invalid-feedback">
                    {formState.errors.NR_TELEFONE_RECEPTIVO_TESTE
                        ? formState.errors.NR_TELEFONE_RECEPTIVO_TESTE.message
                        : ""}
                </div>
            </div>
            <div className="form-group col-12 col-lg-6">
                <label>Número máximo de SMS</label>
                <input
                    className={`form-control placeholder-dark-75 ${
                        formState.errors.NR_MAX_SMS && "is-invalid"
                    }`}
                    type="number"
                    defaultValue={props.configRegua?.NR_MAX_SMS}
                    name="NR_MAX_SMS"
                    min={0}
                    ref={register({
                        min: {
                            value: 0,
                            message: "Insira um número máximo de SMS válido",
                        },
                    })}
                />
                <div className="invalid-feedback">
                    {formState.errors.NR_MAX_SMS
                        ? formState.errors.NR_MAX_SMS.message
                        : ""}
                </div>
            </div>
            {watcher === 1 && (
                <div className="form-group col-12 col-lg-6">
                    <label>Identificador do Zenvia</label>
                    <input
                        className={`form-control placeholder-dark-75 ${
                            formState.errors.DS_ID_AGRUPAMENTO && "is-invalid"
                        }`}
                        type="text"
                        name="DS_ID_AGRUPAMENTO"
                        ref={register()}
                    />
                    <div className="invalid-feedback">
                        {formState.errors.DS_ID_AGRUPAMENTO
                            ? formState.errors.DS_ID_AGRUPAMENTO.message
                            : ""}
                    </div>
                </div>
            )}
        </div>
    );
}
